
import { Vue, Component } from 'vue-property-decorator';
import { ChartActions } from '@/store/actions/charts';
import TimelineChart from '@/components/DataTab/Charts/ChartComponents/TimelineSummaryCharts/TimelineChart.vue';
import {
  ChartReturnType,
  TimelineFormattedType,
  ScenarioNameType,
} from '@/types';
import ChartHeading from '@/components/DataTab/Charts/ChartComponents/ChartHeading.vue';

@Component({
  components: {
    ChartHeading,
    TimelineChart,
  },
})
export default class AvgMinMaxLineChart extends Vue {
  mounted() {
    this.$store.dispatch(ChartActions.CHART_REQUEST, {
      chartId: this.selectedChartId,
      basinId: this.selectedArea.id,
    });
  }

  chartSelection: 'avg' | 'min' | 'max' = 'avg';

  get chartStatus() {
    return this.$store.getters.chartStatus;
  }

  get chartData() {
    const initialData: TimelineFormattedType[] = [];
    this.$store.getters.data.forEach((obj: ChartReturnType) => {
      const value =
        this.chartSelection === 'avg'
          ? obj.avg
          : this.chartSelection === 'min'
          ? obj.min
          : obj.max;
      if (obj.month) {
        initialData.push({
          value: value as number,
          date: obj.month,
          scenario: obj.scenario as ScenarioNameType,
        });
      }
    });

    return initialData;
  }

  get selectedArea() {
    return this.$store.getters.selectedArea;
  }

  get selectedChartId() {
    return this.$store.getters.selectedChart;
  }
}
